import { arrayToMap } from "utils/custom.utils"

export const MESSAGE_TYPES = [
  {
    id: "SMS",
    name: "SMS",
  },
  {
    id: "NTF",
    name: "Notification",
  },
  {
    id: "EML",
    name: "Email",
  },
]

export const MESSAGE_TYPES_MAP = arrayToMap(MESSAGE_TYPES)
